import React from "react";
import { BookOpen, Layers, CheckSquare, Activity, FileText } from "lucide-react";

const KIND_ICONS = {
  lesson: BookOpen,
  flashcards: Layers,
  quiz: CheckSquare,
  scenario: Activity,
  summary: FileText,
};

/** Wrap the first occurrence of `needle` inside `text` with a <mark>. */
export function highlightText(text, needle) {
  if (!needle) return text;
  const i = text.toLowerCase().indexOf(needle.toLowerCase());
  if (i < 0) return text;
  return (
    <>
      {text.slice(0, i)}
      <mark className="bg-sage/20 text-foreground font-semibold rounded px-0.5">
        {text.slice(i, i + needle.length)}
      </mark>
      {text.slice(i + needle.length)}
    </>
  );
}

/**
 * Single row in the global search-modal results list.
 * Keyboard `cursor` state lives in the parent; this row just reflects it.
 */
export default function SearchResultItem({ result, index, active, query, onHover, onPick }) {
  const Icon = KIND_ICONS[result.kind] || BookOpen;
  return (
    <li>
      <button
        onMouseEnter={onHover}
        onClick={onPick}
        data-testid={`search-result-${index}`}
        className={`w-full text-start px-5 py-3 flex gap-3 items-start transition-colors ${
          active ? "bg-sage/5" : "hover:bg-bone/60"
        }`}
      >
        <div
          className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 mt-0.5 ${
            active ? "bg-sage text-white" : "bg-secondary text-sage"
          }`}
        >
          <Icon className="w-4 h-4" strokeWidth={1.8} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-muted-foreground">
            <span>Ch{result.chapter_number}</span>
            <span>·</span>
            <span className="font-medium">{result.kind}</span>
            <span>·</span>
            <span className="truncate text-foreground/80">{result.chapter_title}</span>
          </div>
          <div className="mt-1 text-sm leading-snug line-clamp-2">
            {highlightText(result.snippet, query)}
          </div>
        </div>
      </button>
    </li>
  );
}
